import Swal from 'sweetalert2';
import {
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_ERROR,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_REQUEST,
    WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_SUCCESS,
} from '../../Types/user/Types';
import { workspace_Supporting_DocumentFolder_CreateApi_Restrict } from '../../Apis/user/ApiConfig';

export const workspaces_Supporting_document_FolderCreate_Success = (res) => {
    return {
        type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_SUCCESS,
        payload: res,
    };
};
export const workspaces_Supporting_document_FolderCreate_Error = (error) => {
    return {
        type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_ERROR,
        error: error,
    };
};

export const workspaces_Supporting_document_FolderCreate_Request = (res) => {
    return {
        type: WORKSPACES_SUPPORTING_DOCUMENT_FOLDER_CREATE_RESTRICT_REQUEST,
        payload: res,
    };
};

export const workspaces_Supporting_Document_FolderCreate_Restrict_ActionHandler =
    (workspaceId, data, Navigate, queryParams) => {
        return (dispatch) => {
            dispatch(workspaces_Supporting_document_FolderCreate_Request());
            try {
                workspace_Supporting_DocumentFolder_CreateApi_Restrict(
                    workspaceId,
                    data
                )
                    .then((res) => {
                        if (res) {
                            if (res && res?.data && res?.status === 201) {
                                Swal.fire({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Successfully Created!',
                                    showConfirmButton: false,
                                    timer: 1500,
                                }).then(() => {
                                    const queryParamsObject =
                                        Object.fromEntries(
                                            new URLSearchParams(queryParams)
                                        );
                                    Navigate(
                                        `/workspaces/${queryParamsObject.name}/${queryParamsObject.id}/details`
                                    );
                                });
                                dispatch(
                                    workspaces_Supporting_document_FolderCreate_Success(
                                        res?.data
                                    )
                                );
                            } else {
                                let data = res?.response?.data?.data;
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: 'Something went wrong!',
                                    html: `
                    <p>${data?.name ? data?.name[0] : ''}</p>
                `,
                                    confirmButtonColor: 'rgb(231,52,70)',
                                });
                                dispatch(
                                    workspaces_Supporting_document_FolderCreate_Error(
                                        res
                                    )
                                );
                            }
                        } else {
                            dispatch(
                                workspaces_Supporting_document_FolderCreate_Error(
                                    ''
                                )
                            );
                        }
                    })
                    .catch((err) => {
                        dispatch(
                            workspaces_Supporting_document_FolderCreate_Error(
                                'Something Went Wrong!!!'
                            )
                        );
                    });
            } catch (err) {
                dispatch(
                    workspaces_Supporting_document_FolderCreate_Error(err)
                );
            }
        };
    };
